import { render, staticRenderFns } from "./QueryListItem.vue?vue&type=template&id=3b060c75&"
import script from "./QueryListItem.vue?vue&type=script&lang=ts&"
export * from "./QueryListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports